import React, { useState } from "react";

import { confirmUser } from "services";

import { incompleteMessage, setLocalKlimVar, useAppType, useGetFarmerType, useNavigate, useParams, useToggleNavs, useTranslation } from "utils";

import { ErrorBoundary, Form, MainPage, ProgressBarSteps, ScreenSplit, Message as message } from "components";

import { ConfirmAccountButtons } from "pages/app/account/components/ConfirmAccountButtons";
import { ConfirmAccountStep1 } from "pages/app/account/components/ConfirmAccountStep1";
import { ConfirmAccountStep2 } from "pages/app/account/components/ConfirmAccountStep2";
import { TestimonialScreen } from "pages/app/account/components/TestimonialScreen";

type ConfirmAccountFormType = {
  confirmPassword: string;
  country: string;
  farmName: string;
  firstName: string;
  lastName: string;
  newsletter: boolean | undefined;
  password: string;
  phone: string;
  region: string;
  title: string;
  totalFarmSize: number;
  addressStreet: string;
  addressNumber: string;
  addressCity: string;
  zip: string;
};

export const ConfirmAccount: React.FC = () => {
  const { t } = useTranslation(["signinup", "meta", "enums"]);
  const { token } = useParams<{ token: string }>();
  const [form] = Form.useForm<ConfirmAccountFormType>();
  const navigate = useNavigate();
  const appType = useAppType();
  useToggleNavs(false, appType.mobile);

  const [step, setStep] = useState<number>(1);
  const [loading, setLoading] = useState<boolean>(false);

  const farmerType = useGetFarmerType();

  const complete = (confirmAccountData: ConfirmAccountFormType): void => {
    if (!token) {
      // eslint-disable-next-line no-console
      console.error("Token is required");
      return;
    }

    setLoading(true);
    const controller = new AbortController();

    confirmUser({
      data: { ...confirmAccountData, token },
      signal: controller.signal,
    })
      .then((res) => {
        setLocalKlimVar("token", res.token);
        navigate("/home");

        message({ content: t("confirm.success"), icon: "tick" });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error("Error confirming user", error);
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ScreenSplit sideChildren={<TestimonialScreen farmerType={farmerType} />}>
      <MainPage pageName="sign-in-up" containerClass={appType.mobile ? "small" : "margin-top-0"}>
        <div className="midi-form">
          <Form form={form} name="confirm" onFinish={(v) => complete(v)} onFinishFailed={() => incompleteMessage(t("errors.mandatoryFields"))}>
            <ErrorBoundary>
              {/* @ts-expect-error convert to TS */}
              <ProgressBarSteps totalSteps={2} currentStep={step} />
              <section className={step === 1 ? "container" : "hidden"}>
                <ConfirmAccountStep1 />
              </section>
              <section className={step === 2 ? "container" : "hidden"}>
                <ConfirmAccountStep2 />
              </section>
            </ErrorBoundary>
            <ErrorBoundary>
              <ConfirmAccountButtons loading={loading} setStep={setStep} step={step} />
            </ErrorBoundary>
          </Form>
        </div>
      </MainPage>
    </ScreenSplit>
  );
};
